import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "calendly-verification-wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_4 = {
  key: 1,
  class: "error-container"
}
const _hoisted_5 = {
  key: 2,
  class: "calendly-container"
}

import { ref, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import calendlyService, {
    CalendlyVerificationRequest,
    CalendlyVerificationResponse,
  } from '@/services/calendly/calendly.service';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CalendlyVerificationView',
  setup(__props) {

  const route = useRoute();

  const isLoading = ref(true);
  const isVerified = ref(false);
  const calendlyUrl = ref('');
  const errorMessage = ref('');

  // Load Calendly script and return a promise when it's ready
  const loadCalendlyScript = (): Promise<void> => {
    return new Promise((resolve) => {
      // Check if script is already loaded
      if (
        document.querySelector(
          'script[src*="calendly.com/assets/external/widget.js"]',
        )
      ) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      script.onload = () => {
        // Wait a bit for Calendly to be fully initialized
        setTimeout(() => resolve(), 500);
      };
      document.head.appendChild(script);
    });
  };

  // Initialize Calendly widget manually
  const initializeWidget = () => {
    const widgetElement = document.querySelector(
      '.calendly-inline-widget',
    ) as HTMLElement;
    if (widgetElement && calendlyUrl.value) {
      // Clear any existing content
      widgetElement.innerHTML = '';

      // Check if Calendly is available and initialize
      if ((window as any).Calendly) {
        (window as any).Calendly.initInlineWidget({
          url: calendlyUrl.value,
          parentElement: widgetElement,
        });
      }
    }
  };

  const verifyCode = async () => {
    try {
      const code = route.query.code as string;
      const userId = route.query.userId as string;

      if (!code || !userId) {
        errorMessage.value = 'Missing required parameters: code and userId';
        isLoading.value = false;
        return;
      }

      const verificationData: CalendlyVerificationRequest = {
        code,
        userId,
      };

      const response: CalendlyVerificationResponse =
        await calendlyService.verifyCode(verificationData);

      if (
        !response?.is_used &&
        response?.free_session?.free_session_scheduling_link
      ) {
        isVerified.value = true;

        // Get the base Calendly URL
        const baseCalendlyUrl =
          response?.free_session?.free_session_scheduling_link;

        // Create URL object to handle parameters properly
        const calendlyUrlObj = new URL(baseCalendlyUrl);

        // Forward all current URL parameters to Calendly URL (except code and userId)
        Object.entries(route.query).forEach(([key, value]) => {
          if (
            value !== null &&
            value !== undefined &&
            key !== 'code' &&
            key !== 'userId'
          ) {
            // Convert value to string and set parameter
            calendlyUrlObj.searchParams.set(key, String(value));
          }
        });

        calendlyUrl.value = calendlyUrlObj.toString();

        // Wait for script to load and then initialize widget
        await loadCalendlyScript();
        // Use setTimeout to ensure DOM has updated
        setTimeout(() => {
          initializeWidget();
        }, 100);
      } else {
        errorMessage.value = 'Verification code is already used';
      }
    } catch (error) {
      console.error('Verification error:', error);
      errorMessage.value =
        'An error occurred during verification. Please try again.';
    } finally {
      isLoading.value = false;
    }
  };

  onMounted(() => {
    verifyCode();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "spinner" }, null, -1),
            _createElementVNode("p", null, "Verifying your access...", -1)
          ])))
        : (!isVerified.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "error-icon" }, "⚠️", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Verification Failed", -1)),
              _createElementVNode("p", null, _toDisplayString(errorMessage.value), 1),
              _createElementVNode("button", {
                onClick: verifyCode,
                class: "retry-btn"
              }, "Try Again")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[3] || (_cache[3] = [
              _createElementVNode("h2", null, "Schedule Your Session", -1),
              _createElementVNode("div", { class: "calendly-widget" }, [
                _createElementVNode("div", {
                  class: "calendly-inline-widget",
                  style: {"min-width":"320px","height":"700px"}
                })
              ], -1)
            ])))
    ])
  ]))
}
}

})